'use strict';

var angular = require('angular');
var dependencies = [];
module.exports = angular.module('AVRO.ScheduleChange.WizardTransitionButtons', dependencies).directive('rmWizardTransitionButtons', require('./directives/WizardTransitionButtonsDirective'));